<div class="modal-header">
  <h4 class="modal-title" id="standard-modalLabel">
    {{ "Document" | translate }}
  </h4>
  <button
    type="button"
    class="btn-close"
    (click)="activeModal.dismiss()"
    aria-label="Close"
  ></button>
</div>
<div class="modal-body">
  <form [formGroup]="validationform" class="needs-validation" novalidate>
    <!-- <div class="mb-3">
      <label class="form-label" for="validationCustom01">{{
        "Department Name" | translate
      }}</label>
      <input
        formControlName="name"
        [ngClass]="{     
                    'is-invalid': submit && form['name'].errors,
                  'is-valid': submit && !form['name'].errors, 
                  }"
        type="text"
        class="form-control"
        id="validationCustom01"
        [placeholder]="'Department Name' | translate"
        required
      />
      <div class="valid-feedback">{{ "Looks good" | translate }}</div>
      <div class="invalid-feedback">
        {{ "Please provide a valid department name" | translate }}
      </div>
    </div> -->

    <select2-wrapper
      [label]="'Category' | translate"
      [data]="documentTypes"
      [formControl]="getFormControl('document_type_id')"
      [isSubmitted]="submit"
      [defaultValue]="form['document_type_id'].value"
    />
    <div class="mb-3">
      <label class="form-label" for="file">
        {{ "Document" | translate }}
      </label>

      <div class="input-group">
        <!-- Hidden file input -->
        <input
          type="file"
          id="file"
          class="d-none"
          (change)="onDocumentChange($event)"
          #inputFile
          multiple
        />

        <!-- File button -->
        <!-- for="document_file" -->
        <label
          (click)="inputFile.click()"
          class="input-group-text btn btn-outline-secondary"
        >
          {{ "Choose Files" | translate }}
        </label>

        <!-- Visible textbox with validation state -->
        <input
          type="text"
          class="form-control"
          [ngClass]="{
                        'is-invalid': submit && attachments.value.length === 0,
                      }"
          readonly
          [value]="fileLabel"
        />

        <!-- Feedback messages -->

        <div class="invalid-feedback">
          {{ "Please provide a valid document" | translate }}
        </div>
      </div>
    </div>

    @if (isCategoryOthers) {

    <div class="mb-3">
      <label class="form-label" for="custom_name">{{
        "Custom Category" | translate
      }}</label>
      <input
        formControlName="custom_name"
        [ngClass]="{     
              'is-invalid': submit && form['custom_name'].errors && form['custom_name'].touched,
            }"
        type="text"
        class="form-control"
        id="custom_name"
        [placeholder]="'Custom Category' | translate"
      />
      <div class="valid-feedback">
        {{ "Looks good" | translate }}
      </div>
      <div class="invalid-feedback">
        {{ "Please provide a valid category" | translate }}
      </div>
    </div>
    }

    <div class="mb-3">
      <label class="form-label" for="name">{{
        "Expiry Date" | translate
      }}</label>
      <div
        class="input-group"
        [ngClass]="{     
                'is-invalid': submit && form['expiry_date'].errors,
              }"
      >
        <input
          class="form-control"
          placeholder="dd-mm-yyyy"
          name="dp"
          formControlName="expiry_date"
          ngbDatepicker
          #d="ngbDatepicker"
          [readOnly]="true"
          (click)="d.toggle()"
          [minDate]="todaysDate"
          [ngClass]="{     
                'is-invalid': submit && form['expiry_date'].errors,
              }"
        />

        <button
          [ngClass]="{     
                'is-invalid': submit && form['expiry_date'].errors,
              }"
          class="btn btn-light btn-icon calendar-date"
          (click)="d.toggle()"
          type="button"
        >
          <i class="ti ti-calendar fs-18"></i>
        </button>
      </div>
      <div class="valid-feedback">
        {{ "Looks good" | translate }}
      </div>
      <div class="invalid-feedback">
        {{ "Please provide a valid date" | translate }}
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="activeModal.dismiss()">
    {{ "Close" | translate }}
  </button>
  <button (click)="validSubmit()" type="button" class="btn btn-primary">
    {{ "Save changes" | translate }}
  </button>
</div>
